module.exports = __webpack_public_path__ + "img/hdfc-1.89c02ed7.jpg";